import { api } from '../../base';
import { ISaveJobPayload, ISaveJobServerPayload } from '../../common';
import { IFetchJobOverviewAndResponsibilitiesAction } from '../jobs/redux';

export const fetchJob = (
    jobId: string,
    isCandidate?: boolean,
    referrence?: string | null,
    ck?: string | null
) => {
    const params: Record<string, string> = {};
    if (referrence) {
        params.ref = referrence;
    }
    if (ck) {
        params.ck = ck;
    }
    if (isCandidate) {
        return api.get({ url: `candidatejobs/${jobId}`, queryParams: params });
    }
    return api.get({ url: `jobs/${jobId}`, queryParams: params });
};

export const updateJob = (jobId: string, job: ISaveJobServerPayload) => {
    return api.patch({ url: `jobs/${jobId}/`, data: job });
};

export const updateJobStatus = (jobId: string, status: string) => {
    return api.patch({ url: `jobs/${jobId}/change_status/`, data: { status } });
};

export const deleteJobApi = (jobId: string) => {
    return api.delete({ url: `jobs/${jobId}/` });
};

export const fetchCandidatesJobs = (queryParams: Record<string, string>) => {
    return api.get({ url: `candidatejobs/`, queryParams: queryParams });
};

export const fetchJobsPageStatistics = () => {
    return api.get({ url: `jobs/statistics` });
};

export const fetchJobAttributeListApi = () => {
    return api.get({ url: `jobs/get_job_attribute_list/` });
};

export const fetchJobBenefitsOptionsApi = () => {
    return api.get({ url: `jobbenefitsoptions/` });
};

export const fetchJobRequirementsOptionsApi = (search?: string) => {
    return api.get({
        url: `jobrequirementoptions/`,
        queryParams: { search },
    });
};

export const createJob = (payload: ISaveJobServerPayload) => {
    return api.post({ url: `jobs/`, data: payload });
};

export const fetchAssignedJobList = () => {
    return api.get({ url: `jobs/get_assigned_job_list/` });
};

export const fetchTrackableSources = () => {
    return api.get({ url: `trackablesource/` });
};

export const createTrackableSource = (payload: { name: string }) => {
    return api.post({ url: `trackablesource/`, data: payload });
};

export const fetchTrackableSourceById = (id: string) => {
    return api.get({ url: `trackablesource/${id}/` });
};

export const fetchPublicTrackableSources = () => {
    return api.get({ url: `ptrackablesource/` });
};

export const fetchJobsList = () => {
    return api.get({ url: `jobs/job_label_list` });
};

export const fetchJobRequirementsRecomendations = (jobId: number) => {
    return api.get({
        url: `jobs/${jobId}/get_job_requirements_recommendation/`,
    });
};

export const fetchJobs = (queryParams: Record<string, string>) => {
    return api.get({ url: `jobs/`, queryParams: queryParams });
};

export const fetchJobOverviewAndResponsibilities = (
    payload: IFetchJobOverviewAndResponsibilitiesAction
) => {
    return api.post({
        url: `/jobs/generate_job_description/`,
        data: payload,
    });
};

export const fetchActiveJobCandidates = (
    queryParams: Record<string, string>
) => {
    return api.get({
        url: `job-applications/`,
        queryParams: queryParams,
    });
};
